import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Page.scss';

class Page extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
    html: PropTypes.string.isRequired,
  };

  render() {
    const { html } = this.props;
    return (
      <div className={s.root}>
        <div className={s.container}>
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: html }}
          />
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Page);
